import React from 'react'

function GoogleMap() {
  return (
    <div>
         <div className="album py-2">
                <div className="container">
                    <div className="row">
<iframe width="520" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" title="Shan medical, Dutta Rd, Katwa, West Bengal 713130"  src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Shan%20medical%2C%20Dutta%20Rd%2C%20Katwa%2C%20West%20Bengal%20713130&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
                       
                    </div>
                </div>
            </div>
    </div>
  )
}

export default GoogleMap